import React from 'react';
import { Flex } from '../Flex';
import { type CenterProps } from './Center.types';
/**
 * Centers child element both horizontally and vertically.  If there are multiple
 * children, they will each be shown as a "row", all centered vertically.
 */
const Center: React.FC<CenterProps> = (props) => {
  const { className, style, onClick } = props;
  return (
    <Flex
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      className={className}
      style={style}
      onClick={onClick}
      data-testid="center"
    >
      {props.children}
    </Flex>
  );
};

export default Center;
